import { render, staticRenderFns } from "./CheckboxAcademicLevel.vue?vue&type=template&id=4846df2a&scoped=true&"
import script from "./CheckboxAcademicLevel.vue?vue&type=script&lang=js&"
export * from "./CheckboxAcademicLevel.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxAcademicLevel.vue?vue&type=style&index=0&id=4846df2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4846df2a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
